import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', guestOnly: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { title: '注册', guestOnly: true }
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('@/views/Pricing.vue'),
    meta: { title: '订阅方案' }
  },
  {
    path: '/trial',
    name: 'Trial',
    component: () => import('@/views/Trial.vue'),
    meta: { title: '免费试听' }
  },
  {
    path: '/study',
    name: 'Study',
    component: () => import('@/views/Study.vue'),
    meta: {
      title: '听力学习',
      requiresAuth: true,
      requiresSubscription: true
    }
  },
  {
    path: '/vocabulary',
    name: 'VocabularyBook',
    component: () => import('@/views/VocabularyBook.vue'),
    meta: {
      title: '我的生词本',
      requiresAuth: true,
      requiresSubscription: true
    }
  },
  {
    path: '/wrong-book',
    name: 'WrongBook',
    component: () => import('@/views/WrongBook.vue'),
    meta: {
      title: '错题本',
      requiresAuth: true,
      requiresSubscription: true
    }
  },
  {
    path: '/mondai4',
    name: 'Mondai4',
    component: () => import('@/views/Mondai4.vue'),
    meta: {
      title: '问题四专练',
      requiresAuth: true
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  }
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 更新页面标题
  document.title = to.meta.title
    ? `${to.meta.title} | JLPT耳勉`
    : 'JLPT耳勉 | 听力精练'

  const isLoggedIn = store.getters['auth/isLoggedIn']
  const hasSubscription = store.getters['auth/hasActiveSubscription']

  // 已登录用户不能访问登录/注册页，根据订阅状态决定跳转目标
  if (to.meta.guestOnly && isLoggedIn) {
    return next({ name: hasSubscription ? 'Study' : 'Pricing' })
  }

  // 需要登录的页面
  if (to.meta.requiresAuth && !isLoggedIn) {
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }

  // 需要订阅的页面（已登录但无订阅 → 定价页）
  if (to.meta.requiresSubscription && isLoggedIn && !hasSubscription) {
    return next({ name: 'Pricing' })
  }

  next()
})

// 全局静默 Vue Router 的重定向/重复导航异常
// 这类错误是预期行为（守卫拦截后重定向），不需要报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (
      err.name === 'NavigationDuplicated' ||
      err.name === 'NavigationRedirected' ||
      err.name === 'NavigationCancelled'
    ) return err
    return Promise.reject(err)
  })
}

export default router
